import {useMemo} from 'react';

/**
 * A hook for creating memoized class names based on
 * prop / state conditions.
 */
export function useClasses(classes: {[k: string]: boolean}): string {
  return useMemo(() => {
    return Object.entries(classes)
      .filter(([, value]) => Boolean(value))
      .map(([key]) => key)
      .join(' ');
  }, [classes]);
}
